import { SlideAnnotation } from "pwapi";

import {
  Annotation,
  AnnotationType,
  AreaCountAnnotation,
  PenDrawingAnnotation,
  RegionOfInterestAnnotation,
  TextAnnotation,
  ViewerMode,
} from "custom-models/ViewerTypes";

import {
  ADD_ANNOTATION_REQUEST,
  CHANGE_VIEWER_MODE,
  CLEAR_MINOR_ERROR,
  FETCH_ANNOTATIONS_REQUEST,
  RESET_NEW_PEN_DRAWING,
  SELECT_ANNOTATION,
  SET_EDITED_ANNOTATION,
  SHOW_MASK,
  SLIDE_BARCODE_URL_REQUEST,
  SLIDE_DETAIL_REQUEST,
  SLIDE_REQUEST_RESCAN_REQUEST,
  START_NEW_PEN_DRAWING,
  TOGGLE_ANNOTATION_VISIBILITY,
  WIPE_SLIDE_DETAIL,
  SLIDE_MACRO_URL_REQUEST,
  CASE_BY_ACCESSION_REQUEST,
  DELETE_ANNOTATION_REQUEST,
  EDIT_ANNOTATION_REQUEST,
} from "./constants";
import { toAnnotationRecord } from "../utils/annotations";

export const slideDetail = (id: number) => ({
  type: SLIDE_DETAIL_REQUEST,
  payload: { id },
});

export const slideBarcodeUrl = (slideId: number) => ({
  type: SLIDE_BARCODE_URL_REQUEST,
  payload: {
    slideId,
  },
});

export const slideMacroUrl = (slideId: number) => ({
  type: SLIDE_MACRO_URL_REQUEST,
  payload: { slideId },
});

export const fetchCaseByAccessionNumber = (accession_id: string) => ({
  type: CASE_BY_ACCESSION_REQUEST,
  payload: { accession_id },
});

export const changeViewerMode = (mode: ViewerMode) => {
  return {
    type: CHANGE_VIEWER_MODE,
    payload: {
      viewerMode: mode,
    },
  };
};

export const fetchAnnotations = (slideId: number) => ({
  type: FETCH_ANNOTATIONS_REQUEST,
  payload: { slideId },
});

export const addAnnotation = (annotation: Annotation, slideId: number) => ({
  type: ADD_ANNOTATION_REQUEST,
  payload: { annotation, slideId },
});

export const deleteAnnotation = (slideId: number, annotationId: number) => ({
  type: DELETE_ANNOTATION_REQUEST,
  payload: { annotationId, slideId },
});

export const startNewPenDrawing = (
  newPenDrawing: PenDrawingAnnotation
): any => ({
  type: START_NEW_PEN_DRAWING,
  payload: { newPenDrawing },
});

export const resetNewPenDrawing = () => ({
  type: RESET_NEW_PEN_DRAWING,
});

export const selectAnnotation = (annotation: Annotation | undefined) => ({
  type: SELECT_ANNOTATION,
  payload: { annotation },
});

export const setEditedAnnotation = (annotation: Annotation | undefined) => ({
  type: SET_EDITED_ANNOTATION,
  payload: { annotation },
});

export const commitEditedAnnotation = (
  slideId: number,
  annotation: Annotation,
  label: string | null,
  lesionLineType: string | null,
  subtype: string | null
) => {
  const requestBody: SlideAnnotation =
    annotation && toAnnotationRecord(annotation);
  if (
    annotation.type === AnnotationType.TEXT &&
    (annotation as TextAnnotation).label !== label
  ) {
    requestBody.label = label || null;
  } else if (
    annotation.type === AnnotationType.AREA_COUNT &&
    (annotation as AreaCountAnnotation).label !== label
  ) {
    requestBody.label = label || null;
  } else if (annotation.type === AnnotationType.REGION_OF_INTEREST) {
    const roiAnnotation: RegionOfInterestAnnotation =
      annotation as RegionOfInterestAnnotation;
    if (roiAnnotation.lesionLineType !== lesionLineType) {
      requestBody.lesion_line = lesionLineType as SlideAnnotation.lesion_line;
    }
    if (roiAnnotation.subtype !== subtype) {
      requestBody.subtype = subtype as SlideAnnotation.subtype;
    }
  }

  return {
    type: EDIT_ANNOTATION_REQUEST,
    payload: {
      slideId,
      annotation,
      requestBody,
    },
  };
};

export const toggleAnnotationVisibility = () => {
  return {
    type: TOGGLE_ANNOTATION_VISIBILITY,
  };
};

export const showMask = (maskLesionLineType: string | undefined) => ({
  type: SHOW_MASK,
  payload: { maskLesionLineType },
});

export const wipeSlideDetail = (nextSlideId?: number) => ({
  type: WIPE_SLIDE_DETAIL,
  payload: { nextSlideId },
});

export const clearMinorError = () => ({
  type: CLEAR_MINOR_ERROR,
  payload: {},
});

export const requestSlideRescan = (slideId: number, reason: string) => ({
  type: SLIDE_REQUEST_RESCAN_REQUEST,
  payload: {
    parentLookupSlideId: slideId,
    requestBody: { reason },
  },
});
